<script>
import MealCard from '@/components/atoms/restaurant/MealCard'
import SelectMeal from '@/components/organism/restaurant/SelectMeal'
import { mapGetters } from 'vuex'
import MenuFilter from '@/components/organism/restaurant/MenuFilter.vue'

export default {
    name: 'RestaurantMenu',
    components: { MenuFilter, SelectMeal, MealCard },
    props: {
        categories: null,
        restaurant: null,
        meal: {
            type: Object,
            default: () => {},
        },
        eager: Boolean,
    },
    data() {
        return {
            timeout: null,
            loading: null,
            filters: [],
        }
    },
    computed: {
        ...mapGetters(['smDevice']),
        cart() {
            return this.$cart
        },
        filteredCategories() {
            if (!this.filters.length) {
                return this.categories
            }
            const filtered = this.categories
                .map((category) => {
                    const matchingMeals = category.meals.filter(
                        (meal) =>
                            meal.suitable_for &&
                            meal.suitable_for.some((tag) => this.filters.includes(tag))
                    )
                    if (matchingMeals.length > 0) {
                        return {
                            ...category,
                            meals: matchingMeals,
                        }
                    }
                    return null
                })
                .filter((category) => category !== null)

            return filtered
        },
    },

    mounted() {
        this.findMeal(this.$route.query?.meal)
    },

    methods: {
        async selectMeal(meal) {
            if (!meal) return
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.loading = meal.id
                }, 1000)
                try {
                    await this.$refs.selectMeal.open(meal.id)
                } finally {
                    clearTimeout(this.timeout)
                    this.timeout = null
                    this.loading = null
                }
            }
        },
        findMeal(id) {
            if (!id) return
            this.selectMeal({ id: id })
        },
        setState(isOpen) {
            this.$emit('input', isOpen)
        },
    },
}
</script>

<template lang="pug">
.restaurant-menu(v-if="filteredCategories && filteredCategories.length")
    .menu-category(
        v-for="(category, index) in filteredCategories"
        :key="`menuCategory-${category.id}`"
        :id="`menuCategory-${category.id}`"
        :data-anchor="category.id"
        :class="{'mt-4 pt-2': index}")
        .d-flex.align-items-end.justify-content-between.filter-row
          component(
            v-if="category.name"
            :is="smDevice ? 'h3' : 'h2'"
            :class="{'mb-0': !category.description}").text-nowrap.pr-4 {{category.name}}
          menu-filter(v-if="index===0" v-model="filters" :categories="categories")
        p.text-73.font-size-m.line-1.mb-0(v-if="category.description") {{category.description}}
        .row.mx-lg-n3.mt-3.mt-lg-6.pt-2.row-stretch
            meal-card.px-xl-3.mb-xl-5(
                v-for="(meal, index) in category.meals"
                @click="selectMeal"
                :index="index"
                :max="category.meals ? category.meals.length : 0"
                :key="`meal-${meal.id}`"
                :cart="cart"
                :loading="loading === meal.id"
                :model="meal"
                :eager="eager")
    select-meal(ref="selectMeal" :details="meal" @input="setState")
</template>
